// BSL-URN §5 — Ürün satışına hazırlık turları. Ekran başına en çok 3 balon, metin ≤ 140 karakter.
// Hedef `data-tur` ile işaretli eleman (CSS seçici de olabilir); bulunamayan adım atlanır.
// Bir `data-tur` elemanı silinir/taşınırsa bu dosya aynı commit'te düzeltilir (çatı §12).
export default {
  urunListesi: {
    yol: "/urun/urunlistesi",
    adimlar: [
      { hedef: '[data-tur="urun-yeni"]', metin: "Sattığınız her ürün ve hizmet buradan eklenir." },
      {
        hedef: '[data-tur="urun-liste"] .p-datatable-tbody > tr:not(.p-datatable-empty-message), [data-tur="urun-liste"] [data-kart-satir]',
        metin: "Satıra tıklayıp ürünü düzenleyin. Satmadığınız ürünü silmek yerine pasife alın.",
      },
      { hedef: '[data-tur="urun-liste"] input[placeholder="Ara"]', metin: "Ürün adıyla arayın; pasif ürünleri görmek için listeyi değiştirin." },
    ],
  },
  yeniUrun: {
    yol: "/urun/yeniurun",
    adimlar: [
      { hedef: '[data-tur="urun-ad"]', metin: "Satış ekranında ve fişte görünecek adı yazın." },
      { hedef: '[data-tur="urun-kategori"]', metin: "Kategori ya da alt kategori listede yoksa yazın, «oluştur» deyin.", kavram: "kategori" },
      {
        hedef: '[data-tur="urun-hareket"]',
        metin: "Stoklu ürün mü, hizmet mi, paket mi? Seçim, ürünün satışta nasıl davrandığını belirler.",
        kavram: "hareketTipi",
      },
      // RH-2: alan yalnız hizmet/paket + randevu lisansında görünür; yoksa balon atlanır
      {
        hedef: '[data-tur="urun-randevutip"]',
        metin: "Hizmet ya da paketse Randevu Tipi seçin; satılınca müşteriye seans hakkı açılır.",
        kavram: "hizmetHakki",
      },
    ],
  },
  kategori: {
    yol: "/tanimlamalar/kategori",
    adimlar: [
      { hedef: '[data-tur="kategori-yeni"]', metin: "Yeni kategori buradan açılır; Yeni Ürün'de yazarak da açabilirsiniz." },
      { hedef: '[data-tur="kategori-alt"]', metin: "Ürün alt kategoriye bağlanır; her kategorinin alt kategorileri buradan düzenlenir." },
      { hedef: '[data-tur="kategori-liste"]', metin: "Satış ekranındaki kategori düğmeleri ve raporlardaki gruplar bu listeden gelir." },
    ],
  },
  urunGiris: {
    yol: "/islemler/giris",
    adimlar: [
      { hedef: '[data-tur="giris-urun"]', metin: "Stoğa giren ürünü ve şubeyi seçin. Stoklu ürün ilk girişten sonra satışta görünür." },
      { hedef: '[data-tur="giris-maliyet"]', metin: "Miktarı ve bir adedin KDV hariç maliyetini yazın, toplamı değil.", kavram: "birimMaliyet" },
      { hedef: '[data-tur="giris-kaydet"]', metin: "Kaydedince ürün Ürün Satış ekranında satılabilir olur." },
    ],
  },
};
